module.exports = __webpack_public_path__ + "static/img/toolbar-on.11566ac.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/app-demo/images/toolbar-on.png
// module id = f56F
// module chunks = 12